export default __webpack_public_path__ + "static/media/profile.87e0854f.png";